module.exports = __webpack_public_path__ + "img/hero-paris_s@2x.7cdcd154.webp";